import firebase from 'firebase/compat/app'
import moment from 'moment-timezone'
import { pickBy } from 'lodash'
export default class CloneAccount {
  public static collectionRef(): firebase.firestore.CollectionReference {
    return firebase.firestore().collection('clone_account')
  }

  public static async getById(id: string): Promise<CloneAccount | undefined> {
    const snapshot = await CloneAccount.collectionRef()
      .doc(id)
      .get()
    if (!snapshot.exists || snapshot.data().deleted) return undefined
    return new CloneAccount(snapshot)
  }

  public static getByCompanyIdRealtime(
    companyId: string
  ): firebase.firestore.Query {
    return CloneAccount.collectionRef()
      .where('deleted', '==', false)
      .where('company_id', '==', companyId)
  }

  public static getByCompanyIdAndTypeRealtime(
    companyId: string,
    type: 'own' | 'imported'
  ): firebase.firestore.Query {
    return CloneAccount.collectionRef()
      .where('deleted', '==', false)
      .where('company_id', '==', companyId)
      .where('type', '==', type)
  }

  public static async getByCompanyId(
    companyId: string
  ): Promise<CloneAccount[]> {
    const snapshot = await CloneAccount.getByCompanyIdRealtime(companyId).get()
    return snapshot.docs.map(d => new CloneAccount(d))
  }

  protected _id: string
  protected _data: firebase.firestore.DocumentData
  protected _ref: firebase.firestore.DocumentReference

  constructor(snapshot?: firebase.firestore.DocumentSnapshot) {
    if (snapshot) {
      this._id = snapshot.id
      this._data = snapshot.data() || {}
      this._ref = snapshot.ref
    } else {
      this._ref = CloneAccount.collectionRef().doc()
      this._id = this._ref.id
      this._data = {}
      this.deleted = false
      this.dateAdded = moment()
      this.dateUpdated = moment()
    }
  }

  get id(): string {
    return this._id
  }

  get ref(): firebase.firestore.DocumentReference {
    return this._ref
  }

  get data(): { [key: string]: any } {
    return pickBy(this._data, v => v !== null && v !== undefined)
  }

  get dateAdded(): moment.Moment {
    return moment(this._data.date_added.toMillis())
  }

  set dateAdded(dateAdded: moment.Moment) {
    this._data.date_added = firebase.firestore.Timestamp.fromMillis(
      dateAdded.valueOf()
    )
  }

  get dateUpdated(): moment.Moment {
    return moment(this._data.date_updated.toMillis())
  }

  set dateUpdated(dateUpdated: moment.Moment) {
    this._data.date_updated = firebase.firestore.Timestamp.fromMillis(
      dateUpdated.valueOf()
    )
  }

  get deleted(): boolean {
    return this._data.deleted
  }

  set deleted(deleted: boolean) {
    this._data.deleted = deleted
  }

  get companyId(): string {
    return this._data.company_id
  }

  set companyId(companyId: string) {
    this._data.company_id = companyId
  }

  get locationId(): string {
    return this._data.location_id
  }

  set locationId(locationId: string) {
    this._data.location_id = locationId
  }

  get name(): string {
    return this._data.name
  }

  set name(name: string) {
    this._data.name = name
  }

  get type(): 'own' | 'imported' {
    return this._data.type
  }

  set type(type: 'own' | 'imported') {
    this._data.type = type
  }

  get accountData(): { [key: string]: any } {
    return this._data.account_data
  }

  set accountData(accountData: { [key: string]: any }) {
    this._data.account_data = accountData
  }

  get accountDataUrl(): string {
    return this._data.account_data_url
  }

  set accountDataUrl(accountDataUrl: string) {
    this._data.account_data_url = accountDataUrl
  }

  get shareLocationId(): Array<string> {
    return this._data.share_location_id;
  }

  set shareLocationId(shareLocationId: Array<string>) {
    this._data.share_location_id = shareLocationId;
  }

  public async save(): Promise<CloneAccount> {
    await this._ref.set(this.data)
    return this
  }
}
